module.exports = __webpack_public_path__ + "static/media/logo.6e6496c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderBar/logos/micromd2/logo.svg
// module id = 988
// module chunks = 0